export default {
  state: {
    inviteState: false
  },
  mutations: {
    refreshInviteState(state,payload) {
      state.inviteState = payload
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/setting.js